/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const deleteMedia = ({ id }) => axios.delete(`media/${id}`);